module.exports = __webpack_public_path__ + "static/media/english.39cd11ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/english.svg
// module id = 374
// module chunks = 1